import { Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useCollectionAPI } from '../hooks/useCollectionAPI';

export const GenerateGNR = () => {
  const { generateGnr, gnrData } = useCollectionAPI();

  return (
    <div style={{ width: '100%' }}>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Typography
            color={'primary'}
            sx={{ textAlign: 'center' }}
            variant="h5"
            className="mt-0"
          >
            Generate GNR
          </Typography>
        </Grid>
      </Grid>
      <div style={{ margin: '5px 15px', borderTop: '2px solid #25BCCA' }}></div>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Stack spacing={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => generateGnr()}
            >
              Generate Gnr
            </Button>
          </Stack>
        </Grid>
      </Grid>
      {gnrData?.grnNo && (
        <div style={{ padding: '5px 15px' }}>
          <p>
            <strong>GRN No:</strong> {gnrData?.grnNo}
          </p>
          <p>
            <strong> GNR Summary Report</strong>
          </p>
          {gnrData?.items && (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>
                    Item
                  </th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>
                    Qty
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(gnrData.items).map(([item, qty]) => (
                  <tr key={item}>
                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                      {item}
                    </td>
                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                      {String(qty)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      fontWeight: 'bold',
                    }}
                  >
                    Total
                  </td>
                  <td
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      fontWeight: 'bold',
                    }}
                  >
                    {Object.values(gnrData.items).reduce(
                      (acc, curr) => acc + Number(curr),
                      0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};
